import { ComponentKewlox } from './ComponentKewlox';
import { RodEntity, SearchInfo } from '../Data';

export class DrawerSlat extends ComponentKewlox {
  readonly width: number;

  static _lookup = ['width'];

  constructor(
    id: number,
    name: string,
    reference: string,
    price: number,
    weight: number,
    forSales: boolean,
    visible: boolean,
    height: number,
    width: number,
  ) {
    super(id, name, reference, price, weight, forSales, visible, height);
    this.width = width;
  }

  get typeComponent() {
    return 'DrawerSlat';
  }

  static fromJSON(json: RodEntity): DrawerSlat {
    const obj = Object.create(DrawerSlat.prototype);
    return Object.assign(obj, this, json);
  }

  static reviver(key: string, value: any): any {
    return key === '' ? DrawerSlat.fromJSON(value) : value;
  }

  compareTo(otherComponent: ComponentKewlox): number {
    return this.width - (otherComponent as DrawerSlat).width;
  }

  static getSearchInfos(width: number): SearchInfo {
    const height = 22;
    return {
      lookup: DrawerSlat._lookup,
      key: { height, width },
    };
  }

  getKey(): string {
    return DrawerSlat.generateKey(this.width);
  }

  static generateKey(width: number) {
    const searchInfos = DrawerSlat.getSearchInfos(width);
    return JSON.stringify(searchInfos.key);
  }
}
